export default {
  "1": {
    question: "أغسل يديك بانتظام.",
    answer:
      "على خاطر غسلان اليدين بالماء و الصابون ديما يقتل الفيروسات إلي على اليدين، اليدين إلى هوما أكبر ناقل للفيروس الكورونا."
  },
  "2": {
    question: "النظافة التنفسية لازمة.",
    answer:
      "معناها الحرص بش تغطي فمك و خشمك بمنديل ورقي وقت تعطس ولا تكح. و مباشرة تمشي تطيش المنيل المستعمل و تغسل يديك."
  },
  "3": {
    question: "ماتمسش وجهك قدر المستطاع.",
    answer:
      "نعرفوا إلي هي حاجة صعيبة، أما الفيروش كي يبدا على يديك و بعد ينتقل لوجهك ينجم يدخل للبدن عن طريف العينين و الفم و الخشم."
  },
  "4": {
    question: "ماتقربش للناس.",
    answer:
      "ديما خوذ مسافة أمان بينك وبين كل عبد أكثر من متر بش إذا كان إنت مريض و مافيبالكش ماتنقلوش العدوى و بش بش ماتستقبلش العدوى كان هو حامل للفيروس."
  }
};
